var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.displayType === 'inline')?_c('div',{ref:"calendlyForm",staticClass:"calendly-inline-widget",staticStyle:{"min-width":"320px","height":"830px"},attrs:{"data-url":_vm.url,"scrolling":"no","frameborder":"0","allowtransparency":"true"}}):_c('div',{on:{"click":_vm.openCalendly}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }